import "../../src/assets/styles/Header.css";
import logo from "../imgs/logo.png";
import iconBack from "../icons/icon-back-2.png";
import { useNavigate } from "react-router-dom";
function Header({ isPageSearch, pageToAcction, data }) {
  const navigate = useNavigate();
  const backToSearch = () => {
  if (pageToAcction) navigate(pageToAcction,  { state: data })
  else navigate("/");
  };

  return (
    <div>
      <div className="status-bar"></div>
      <div className="header">
        <div className="header-logo">
          {!isPageSearch && (
            <img
              className="img-icon-back"
              style={{ cursor: "pointer" }}
              src={iconBack}
              alt="icon-back"
              id="btn-back"
              onClick={backToSearch}
            />
          )}
          <div className="main-logo">
            <img src={logo} alt="logo"></img>
          </div>
        </div>
        <p>HỖ TRỢ KHÁCH HÀNG</p>
      </div>
    </div>
  );
}

export default Header;
